import type { StockStatusElements } from "@jti/fe-common";

import { isInStock } from "@product-details/utils/stockStatus";

type Product = {
  id: string;
  label: string;
  sku: string;
  swatchData: string;
  url: string;
};

export const getOptionsForSwatch = (config: Product[], isColorValue = true, stock?: StockStatusElements) =>
  config.map((data) => ({
    label: data.label,
    value: isColorValue ? data.swatchData : data.id,
    additionalData: data,
    color: data.swatchData,
    isInStock: stock ? data.sku !== undefined && isInStock(stock[data.sku]) : true,
    stockStatus: stock?.[data.sku],
    isDisabled: stock?.[data.sku] === "OUT_OF_STOCK",
  }));

export const getOptionsForSwatchById = (config: Product[], isColorValue = true, stock?: StockStatusElements) =>
  config.map((data) => ({
    label: data.label,
    value: isColorValue ? data.swatchData : data.id,
    additionalData: data,
    color: data.swatchData,
    isInStock: stock ? data.id !== undefined && isInStock(stock[data.id]) : true,
    stockStatus: stock?.[data.id],
    isDisabled: stock?.[data.id] === "OUT_OF_STOCK",
  }));
